import { memo } from 'react';
import { cnsIpiTotalPoint, lineHeightStyle } from '../../../../utils/helpers';
import ChiefComplainDeleteBtn from '../chiefComplainDeleteBtn';

const flexRow = { display: 'flex', justifyContent: 'space-between', alignItems: 'center' };

const OncologyExamination = ({
  selectedOnExamination,
  setSelectedOnExamination,
  prescriptionItems,
  isHistoryPage = false,
}) => {
  let { oncologyExamination } = selectedOnExamination;

  const deleteData = (itemName) => {
    selectedOnExamination.oncologyExamination[itemName] = false;
    setSelectedOnExamination({ ...selectedOnExamination });
  };

  return (
    <div className="oncology-examination-view" style={lineHeightStyle('on-examination', prescriptionItems)}>
      {oncologyExamination?.isShowAuc && oncologyExamination?.aucResult && (
        <div style={flexRow}>
          <span className="text-left">
            AUC: {oncologyExamination?.aucResult} mg
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn
              action={deleteData}
              itemName={'isShowAuc'}
            />
          )}
        </div>
      )}
      {oncologyExamination?.isShowCnsIpi && (
        <div style={flexRow}>
          <span className="text-left">
            CNS-IPI: {cnsIpiTotalPoint(oncologyExamination)}
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn
              action={deleteData}
              itemName={'isShowCnsIpi'}
            />
          )}
        </div>
      )}
      {oncologyExamination?.isShowMmIss && (
        <div style={flexRow}>
          <span className="text-left">
            MM-ISS: {oncologyExamination?.mmIssResult?.stage}
          </span>
          {/* <div className="pl-2 font-italic">
            - Median survival is {oncologyExamination?.mmIssResult?.survivalMonths} months
          </div> */}
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn
              action={deleteData}
              itemName={'isShowMmIss'}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default memo(OncologyExamination);
